import script from "./PriceSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceSetting.vue?vue&type=script&setup=true&lang=js"

import "./PriceSetting.vue?vue&type=style&index=0&id=bd76e2ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd76e2ba"]])

export default __exports__